const initialState = {
  status: "invalid",
  data: {
    week: {},
    two_weeks: {},
    month: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "PACKAGE_BOXES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PACKAGE_BOXES_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "PACKAGE_BOXES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
